export default "__VITE_ASSET__JnOFOHI5__"